/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\FooterLiStyled.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 15th 2023, 4:48:33 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const FooterLiStyled = styled.li.attrs((props: any) => ({
    bgColor: props.bgColor,
}))`
width: fit-content;
list-style: none;
padding: 0.4rem;
color: var(--text-color-first);
text-align: center;
&:hover{
    text-decoration: underline ${(props: any) => getThemeColor(props.bgColor)};
}
& > a,
a:visited {
    color:var(--text-color-first);
}
`;

export default FooterLiStyled;
